import { memo } from 'react';
import ChatStream from './ChatStream';

const ChatStreamView = memo(function ChatStreamView({
    blocks,
    isStreaming,
    brand,
    placeholderHeight,
    liveRef,
    interruptSessionId,
    onApprove,
    onReject,
    onEdit,
    onRetry,
    isSubmitting,
    sessionId,
    cta,
    onCtaClick,
}) {
    return (
        <ChatStream
            blocks={blocks}
            isStreaming={isStreaming}
            brand={brand}
            placeholderHeight={placeholderHeight}
            liveRef={liveRef}
            onApprove={onApprove}
            onReject={onReject}
            onEdit={onEdit}
            onRetry={onRetry}
            isSubmitting={isSubmitting}
            showApprovalUI={!!interruptSessionId}
            sessionId={sessionId}
            cta={cta}
            onCtaClick={onCtaClick}
        />
    );
});

export default ChatStreamView;
